import { render, staticRenderFns } from "./CourseViewUserTimelineCard.vue?vue&type=template&id=5824ab65&"
import script from "./CourseViewUserTimelineCard.vue?vue&type=script&lang=js&"
export * from "./CourseViewUserTimelineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports